class HHZoomGallery extends HTMLElement {
  constructor() {
    super()

    this.currentSlideCountElement = this.querySelector('[data-current-slide-counter]');
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector('.swiper-nav-btn-next'),
        prevEl: this.querySelector('.swiper-nav-btn-prev'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination-bullets'),
        clickable: true,
      },
      zoom: true,
      on: {
        slideChange: () => {
          this.updateFraction()
          this.updateActiveSlideInteraction()
        },
        // Fired just before Swiper disables the edge arrow (toEdge)
        reachEnd: () => this.handOffEdgeFocus('next'),
        reachBeginning: () => this.handOffEdgeFocus('prev'),
      },
    });

    this.updateActiveSlideInteraction();
  }

  // Disabling the focused arrow drops focus to <body>, so hand focus to the
  // opposite arrow first (ASL-996)
  handOffEdgeFocus(edge) {
    const { nextEl, prevEl } = this.swiper?.navigation || {}
    const leaving = edge === 'next' ? nextEl : prevEl
    const target = edge === 'next' ? prevEl : nextEl
    if (!leaving || !target || document.activeElement !== leaving) return
    if (this.swiper.isBeginning && this.swiper.isEnd) return

    // With two slides the opposite arrow is still disabled from the other edge
    // (Swiper re-enables it on fromEdge, after this), and focus() ignores it
    target.disabled = false
    target.focus()
  }

  updateFraction() {
    if (!this.currentSlideCountElement) return
    this.currentSlideCountElement.textContent = this.swiper.activeIndex + 1
  }

  updateActiveSlideInteraction() {
    if (!this.swiper) return

    const activeSlide = this.swiper.slides[this.swiper.activeIndex]
    const isModelSlide = activeSlide?.dataset?.mediaType === 'model'

    this.swiper.allowTouchMove = !isModelSlide
  }
}

customElements.define('hh-zoom-gallery', HHZoomGallery)
